import React from 'react';

/**
 * Stacked "Label: value" lines with the value in bold, green for `tone: 'success'`.
 * @param {{ rows: { label: string, value: React.ReactNode, tone?: 'success' }[] }} props
 */
const LabeledValues = ({ rows }) => (
    <div className="flex min-w-0 flex-col gap-0.5">
        {rows.map(({ label, value, tone }) => (
            <span key={label} className="break-words text-sm text-foreground/80">
                {label}:{' '}
                <span className={`font-semibold ${tone === 'success' ? 'text-primary' : 'text-foreground'}`}>
                    {value}
                </span>
            </span>
        ))}
    </div>
);

export default LabeledValues;
